/**
 * Copyright © 2025 Farmlands Co-operative Society Limited. All rights reserved.
 *
 * This document contains confidential information and is the property of Farmlands.
 * Unauthorised reproduction or distribution of any part of this publication is prohibited without written consent.
 */

import * as yup from 'yup';

export const emailSchema = yup
  .string()
  .email()
  .matches(/^[^\s@]+@[^\s@]+\.[^\s@]+$/, 'Please enter a valid email address');

export const isInvalidEmail = (email: string | undefined) => {
  if (!email?.length) {
    return 'Email address is required';
  }
  
  try {
    emailSchema.validateSync(email);
    return undefined;
  } catch (error) {
    return 'Please enter a valid email address';
  }
};